export const HERO_SCRIPT = [
    { type: "system", text: "New lead received" },
    { from: "customer", text: "Hi, are you available for a consultation this week?" },
    { from: "ai", text: "Absolutely! I can help with that. We have openings Wednesday at 2:00 PM or Thursday at 10:00 AM. Which works better for you?" },
    { from: "customer", text: "Thursday at 10 works." },
    { from: "ai", text: "Perfect! You're booked for Thursday at 10:00 AM. You'll receive a confirmation shortly." },
    { type: "badge", text: "Appointment Booked" },
];

export const DEMO_TABS = [
    {
        id: "new-lead",
        label: "New Lead",
        script: [
            { from: "customer", text: "Hi, I'm interested in your service. How much does it cost?" },
            { from: "ai", text: "Thanks for reaching out! I'd be happy to help. May I ask what service you're looking for?" },
            { from: "customer", text: "I'm looking for a quote for my house." },
            { from: "ai", text: "Absolutely. I can get that started. What is the best address for the property?" },
            { type: "badge", text: "Lead Captured" },
        ],
    },
    {
        id: "missed-call",
        label: "Missed Call",
        script: [
            { type: "system", text: "Missed Call Detected" },
            { from: "customer", text: "Hi, I just tried calling. Are you open today?" },
            { from: "ai", text: "Hi! Sorry we missed your call. Yes, we're open today. What can I help you with?" },
            { from: "customer", text: "I need to schedule an appointment." },
            { from: "ai", text: "Absolutely. I can help with that. Would you prefer morning or afternoon?" },
            { type: "badge", text: "Conversation Started" },
        ],
    },
    {
        id: "appointment",
        label: "Appointment",
        script: [
            { from: "customer", text: "Can I move my appointment to Friday?" },
            { from: "ai", text: "Of course! I have Friday at 10 AM or 2 PM available. Which works better?" },
            { from: "customer", text: "2 PM." },
            { from: "ai", text: "Done! Your appointment has been moved to Friday at 2 PM." },
            { type: "badge", text: "Calendar Updated" },
        ],
    },
    {
        id: "follow-up",
        label: "Follow-Up",
        script: [
            { from: "ai", text: "Hi John! Just checking in about the estimate we sent last week. Do you have any questions?" },
            { from: "customer", text: "Yes, can you explain the pricing?" },
            { from: "ai", text: "Absolutely. I can walk you through it or arrange a quick call with the team." },
            { type: "badge", text: "Lead Re-engaged" },
        ],
    },
    {
        id: "review-request",
        label: "Review Request",
        script: [
            { from: "ai", text: "Hi Sarah! We hope you were happy with your recent service. We'd love to hear about your experience." },
            { from: "customer", text: "Everything was great!" },
            { from: "ai", text: "That's wonderful! Would you mind leaving us a quick Google review?" },
            { type: "badge", text: "Review Request Sent" },
        ],
    },
];

export const SERVICES = [
    { num: "01", title: "AI Lead Response", desc: "Respond to new leads instantly and keep the conversation moving.", example: [
        { from: "customer", text: "How much does a roof inspection cost?" },
        { from: "ai", text: "Happy to help! Can I get the property address for an accurate quote?" },
    ] },
    { num: "02", title: "Missed Call Text Back", desc: "Turn missed calls into conversations automatically.", example: [
        { type: "system", text: "Missed Call Detected" },
        { from: "ai", text: "Sorry we missed you! We're open Saturday 9–2. Want me to book you in?" },
    ] },
    { num: "03", title: "Appointment Booking", desc: "Let customers schedule appointments without back-and-forth.", example: [
        { from: "customer", text: "Can I come in Tuesday?" },
        { from: "ai", text: "Tuesday at 11 AM or 3 PM — which works better for you?" },
    ] },
    { num: "04", title: "Lead Follow-Up", desc: "Automatically follow up until the lead responds, books, or opts out.", example: [
        { from: "ai", text: "Hi Mark, following up on your quote — any questions?" },
        { from: "customer", text: "Yes, can we talk tomorrow?" },
    ] },
    { num: "05", title: "Lead Nurturing", desc: "Stay connected with prospects who aren't ready today.", example: [
        { from: "ai", text: "Hi Ana, still planning your remodel? We have a seasonal offer this month." },
        { from: "customer", text: "Actually yes — let's talk." },
    ] },
    { num: "06", title: "Review Automation", desc: "Automatically request reviews from happy customers.", example: [
        { from: "ai", text: "Thanks for choosing us! Would you mind leaving a quick Google review?" },
        { from: "customer", text: "Done — 5 stars!" },
    ] },
    { num: "07", title: "Reactivation Campaigns", desc: "Bring old and inactive leads back into the conversation.", example: [
        { from: "ai", text: "Hi Sam, it's been a while — we have openings this week if you still need us." },
        { from: "customer", text: "Great timing. Book me in." },
    ] },
    { num: "08", title: "SMS & Email Automation", desc: "Deliver the right message at the right time.", example: [
        { type: "system", text: "Quote sent via email" },
        { from: "ai", text: "Just sent your estimate — reply here with any questions." },
    ] },
    { num: "09", title: "CRM Automation", desc: "Automatically organize leads, update pipelines, tag contacts, and trigger workflows.", example: [
        { type: "system", text: "Lead tagged: Hot" },
        { type: "system", text: "Pipeline updated → Appointment Set" },
        { type: "badge", text: "Team Notified" },
    ] },
    { num: "10", title: "AI Customer Support", desc: "Answer common customer questions 24/7.", example: [
        { from: "customer", text: "What are your hours?" },
        { from: "ai", text: "We're open Mon–Sat, 8 AM–6 PM. Anything else I can help with?" },
    ] },
];

export const INDUSTRIES = [
    { name: "Real Estate", icon: "Building2", example: ["Is this property still available?", "Yes, it is! Would you like to schedule a viewing?"] },
    { name: "Home Services", icon: "Hammer", example: ["Do you offer free estimates?", "We do! I can book your estimate this week — what day suits you?"] },
    { name: "Plumbing", icon: "Wrench", example: ["My sink is leaking — can someone come today?", "Sorry to hear that! We have a technician available at 3 PM. Shall I book it?"] },
    { name: "HVAC", icon: "Thermometer", example: ["My AC stopped working.", "I can help. Is this for a home or business? We have openings tomorrow morning."] },
    { name: "Roofing", icon: "HardHat", example: ["I need a roof replacement quote.", "Absolutely. What's the property address so we can start your quote?"] },
    { name: "Landscaping", icon: "Leaf", example: ["Do you do weekly lawn care?", "Yes! What's your address and lot size? I'll get you a price today."] },
    { name: "Cleaning", icon: "SprayCan", example: ["How much for a deep clean?", "Happy to quote that! How many bedrooms and bathrooms?"] },
    { name: "Automotive", icon: "Car", example: ["Can I book an oil change?", "Of course — tomorrow at 9 AM or 1 PM. Which works for you?"] },
    { name: "Med Spas", icon: "Sparkles", example: ["Do you offer consultations for fillers?", "Yes, complimentary! I can book you Thursday at 4 PM. Does that work?"] },
    { name: "Salons", icon: "Scissors", example: ["Any openings for a cut and color this weekend?", "Saturday at 11 AM just opened up — want me to grab it for you?"] },
    { name: "Dental", icon: "Smile", example: ["I need to reschedule my cleaning.", "No problem! Next Tuesday at 8 AM or Wednesday at 5 PM?"] },
    { name: "Professional Services", icon: "Briefcase", example: ["I'd like to discuss my case.", "Of course. I can schedule a call with our team — morning or afternoon?"] },
];

export const FAQS = [
    { q: "What exactly does the AI do?", a: "It handles the routine conversations that eat up your day: answering new leads instantly, texting back missed calls, booking appointments, following up, and requesting reviews — all in your business's voice." },
    { q: "Will customers know they're talking to AI?", a: "The experience feels natural, fast, and helpful — like a great receptionist. If a customer asks, the AI is honest, and it knows when to hand the conversation to a real person on your team." },
    { q: "Can it book appointments?", a: "Yes. It connects to your calendar, offers real available times, books the appointment, and sends confirmations and reminders automatically." },
    { q: "Can it respond to missed calls?", a: "Yes. The moment a call is missed, the AI texts the caller back within seconds and starts a conversation — so the lead never slips away." },
    { q: "Can it send SMS and email?", a: "Yes. It reaches customers by text message and email, choosing the right channel and timing for each situation." },
    { q: "Can it follow up with leads automatically?", a: "Yes. It follows up consistently — politely and persistently — until the lead responds, books, or asks to be left alone." },
    { q: "Can it work with my existing CRM?", a: "Almost certainly. It connects with the most popular CRMs, calendars, and booking tools, and keeps your leads organized and tagged automatically." },
    { q: "Do I need to learn complicated software?", a: "No. We set everything up and manage it for you. You simply watch appointments appear and leads get handled." },
    { q: "Can you customize it for my business?", a: "Yes — everything is built around your services, your pricing rules, your tone of voice, and the way you want customers handled." },
    { q: "Can I talk to a real person when needed?", a: "Always. The AI knows its limits. When a conversation needs a human, it hands off smoothly and notifies your team right away." },
    { q: "What is an AI employee?", a: "A trained digital team member for your business — it answers inquiries, books appointments, follows up with leads, and handles repetitive customer communication 24/7, built around your services and your way of working." },
    { q: "How much does Flowtech cost?", a: "Plans start at $299 per month. Every system is tailored to your business, so your free automation audit confirms the plan that fits your lead volume and goals." },
    { q: "Does Flowtech require a setup fee?", a: "No. There is no setup fee — onboarding, build-out, and training of your AI employee are included in your monthly plan." },
    { q: "What businesses can use Flowtech?", a: "Any service-based business — contractors, HVAC, plumbing, roofing, cleaning, landscaping, automotive, real estate, med spas, salons, dental, and professional services — anywhere in the United States. Setup is fully remote." },
    { q: "How do I get started?", a: "Start a free chat interview through the form on this page. We learn about your business, show you exactly what can be automated, and build your system for you." },
];

export const FINAL_SCRIPT = [
    { type: "system", text: "New Lead Received" },
    { from: "ai", text: "Hi! Thanks for reaching out. How can I help you today?" },
    { from: "customer", text: "I need a quote for my project." },
    { from: "ai", text: "I'd be happy to help with that. Can I grab a few quick details?" },
    { type: "badge", text: "Lead Responded" },
    { type: "badge", text: "Appointment Booked" },
];
